import { RefObject, useState, useRef, useLayoutEffect } from 'react';

export const useEllipsisTooltipForTableCells = (): [
  ref: RefObject<HTMLDivElement> | null,
  overflowActive: boolean
] => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [overflowActive, setOverflowActive] = useState<boolean>(false);

  const isOverFlowActive = () => {
    if (!overflowActive) {
      const element = ref.current;
      if (element) {
        setOverflowActive(
          element.offsetWidth < element.scrollWidth ||
            element.offsetHeight < element.scrollHeight
        );
      }
    }
  };

  useLayoutEffect(() => {
    window.addEventListener('resize', isOverFlowActive);
    return () => {
      window.removeEventListener('resize', isOverFlowActive);
    };
  }, []);

  useLayoutEffect(() => {
    isOverFlowActive();
  }, [ref?.current?.offsetWidth]);
  return [ref, overflowActive];
};
